import React from 'react'
import styles from './EmptyRoutes.scss'
import {Card} from 'common/styleguide/Card'
import {Icon} from 'common/Icon'
import {CTA} from 'common/styleguide/CTA'

export class EmptyRoutes extends React.PureComponent {
  render () {
    return (
      <div className={styles.EmptyRoutes}>
        <h2 data-heading-alt>Routes</h2>
        <Card className={styles.mainCard}>
          <Icon i='route-graphic' size={100} />
          <h1 data-heading-alt className={styles.buildYourRide}>Build Your Ride</h1>
          <div className={styles.leadText}>
            <h2>Use the route planner to create completely custom routes and cuesheets. Just click on the map to plot your route, and the planner will take care of the cuesheet automatically.  </h2>
          </div>
          <CTA margins={false} href='/routes/new'>Plan a Route</CTA>
        </Card>
      </div>
    )
  }
}
